import { render } from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=template&id=21f20a9a&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=style&index=0&id=21f20a9a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f20a9a"]])

export default __exports__